/** Browser Notification helpers for Insights HITL when the tab is in the background. */

export function insightsTabIsBackground(): boolean {
  if (typeof document === "undefined") return false;
  return document.visibilityState === "hidden";
}

export function insightsNotificationsSupported(): boolean {
  return typeof window !== "undefined" && "Notification" in window;
}

/** Request permission (call from a user gesture when possible). */
export async function ensureInsightsNotificationPermission(): Promise<
  NotificationPermission | "unsupported"
> {
  if (!insightsNotificationsSupported()) return "unsupported";
  if (Notification.permission === "granted" || Notification.permission === "denied") {
    return Notification.permission;
  }
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}

/**
 * Show a HITL notification only when permission is granted and the tab is not focused.
 * Returns the Notification instance, or null if skipped.
 */
export function notifyInsightsHitl(options: {
  question: string;
  threadId: string;
  toolCallId?: string;
}): Notification | null {
  if (!insightsNotificationsSupported()) return null;
  if (Notification.permission !== "granted") return null;
  if (!insightsTabIsBackground()) return null;

  const body = options.question.replace(/\s+/g, " ").trim();
  if (!body) return null;

  const tag =
    options.toolCallId != null && options.toolCallId !== ""
      ? `insights-hitl-${options.threadId}-${options.toolCallId}`
      : `insights-hitl-${options.threadId}`;

  try {
    const notification = new Notification("Insights needs your input", {
      body: body.length > 140 ? `${body.slice(0, 137)}…` : body,
      tag,
      renotify: true,
    });
    notification.onclick = () => {
      try {
        window.focus();
      } catch {
        // ignore
      }
      notification.close();
    };
    return notification;
  } catch {
    return null;
  }
}
